import React, { useState, useEffect } from 'react';
import { Phone, MessageCircle } from 'lucide-react';

const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const phoneNumber = '+4923139085116';
  const displayPhone = '0231 39085116';
  const whatsappLink = `https://wa.me/4923139085116?text=Hallo, ich benötige Hilfe beim Schlüsseldienst`;

  useEffect(() => {
    // Delay showing the sticky CTA to improve initial page load
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000); // Show after 1 second

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-4 z-40 md:hidden animate-slide-up" 
      data-testid="sticky-cta"
      style={{ animation: 'slideUp 0.3s ease-out' }}
    >
      <div className="flex gap-3 max-w-md mx-auto">
        <a
          href={`tel:${phoneNumber}`}
          className="flex-1 bg-orange-600 hover:bg-orange-700 text-white px-4 py-3 rounded-full font-bold text-center transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2"
          data-testid="sticky-cta-call"
          aria-label={`Jetzt anrufen: ${displayPhone}`}
        >
          <Phone size={20} />
          <span>Jetzt anrufen</span>
        </a>
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 bg-green-600 hover:bg-green-700 text-white px-4 py-3 rounded-full font-bold text-center transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2"
          data-testid="sticky-cta-whatsapp"
          aria-label="WhatsApp Nachricht senden"
        >
          <MessageCircle size={20} />
          <span>WhatsApp</span>
        </a>
      </div>
    </div>
  );
};

export default StickyCTA;
